import * as Dtos from '../api/Neon.Dtos';

export interface IDrugShipmentDepotBatchSummary {
    depotBatchId: number;
    drugUnits: number;
    drugUnitsUsed: number;
    drugUnitsDamaged: number;
    drugUnitsDestroyed: number;
    drugUnitsLost: number;
    drugUnitsQuarantined: number;
    drugRemaining: number;
    batch: Dtos.Batch;
};

export const getDrugUnavailable = (drugShipmentDepotBatch: Dtos.DrugShipmentDepotBatch): number => {
    return (drugShipmentDepotBatch.drugUnitsDamaged! +
        drugShipmentDepotBatch.drugUnitsDestroyed! +
        drugShipmentDepotBatch.drugUnitsLost! +
        drugShipmentDepotBatch.drugUnitsQuarantined! +
        drugShipmentDepotBatch.drugUnitsUsed!);
};

export const getDrugRemaining = (drugShipmentDepotBatch: Dtos.DrugShipmentDepotBatch): number => {
    return drugShipmentDepotBatch.drugUnits! - getDrugUnavailable(drugShipmentDepotBatch);
};

export const createDrugShipmentDepotBatchSummary = (drugShipmentDepotBatch: Dtos.DrugShipmentDepotBatch): IDrugShipmentDepotBatchSummary => {
    const drugShipmentDepotBatchSummary: IDrugShipmentDepotBatchSummary = Object.assign({},
        { ...drugShipmentDepotBatch },
        { batch: drugShipmentDepotBatch.depotBatch.batch }) as any;

    drugShipmentDepotBatchSummary.drugRemaining = getDrugRemaining(drugShipmentDepotBatch);

    return drugShipmentDepotBatchSummary;
}

export const sumDrugShipmentDepotBatches = (firstDrugShipmentDepotBatch: IDrugShipmentDepotBatchSummary,
    secondDrugShipmentDepotBatch: IDrugShipmentDepotBatchSummary): IDrugShipmentDepotBatchSummary => {
    firstDrugShipmentDepotBatch.drugUnits += secondDrugShipmentDepotBatch.drugUnits;
    firstDrugShipmentDepotBatch.drugUnitsUsed += secondDrugShipmentDepotBatch.drugUnitsUsed;
    firstDrugShipmentDepotBatch.drugUnitsDamaged += secondDrugShipmentDepotBatch.drugUnitsDamaged;
    firstDrugShipmentDepotBatch.drugUnitsDestroyed += secondDrugShipmentDepotBatch.drugUnitsDestroyed;
    firstDrugShipmentDepotBatch.drugUnitsLost += secondDrugShipmentDepotBatch.drugUnitsLost;
    firstDrugShipmentDepotBatch.drugUnitsQuarantined += secondDrugShipmentDepotBatch.drugUnitsQuarantined;
    firstDrugShipmentDepotBatch.drugRemaining += secondDrugShipmentDepotBatch.drugRemaining;

    return firstDrugShipmentDepotBatch;
};